/* @Todo Update the Header
   - If you change the urls, you will need to update the routes in the app in src/app.tsx
*/
export const headerData = {
    name: "Your Name",
    heading1: {
        name: "About",
        url: "/about"
    },
    heading2: {
        name: "Resume",
        url: "/resume"
    },
    heading3: {
        name: "Writing Samples",
        url: "/samples"
    },
    heading4: {
        name: "Contact",
        url: "/contact"
    },
}
